var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapShield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.852,
    height: 21.608,
    viewBox: "0 0 19.852 21.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-shield",
    "data-name": "Icon map-shield",
    d: "M1.837-28.707a9.139,9.139,0,0,1,1.441-4.277L.126-36A6.007,6.007,0,0,1-3.3-34.65a6.3,6.3,0,0,1-3.376-.63,6.755,6.755,0,0,1-3.376.63,6.241,6.241,0,0,1-3.286-1.215l-3.2,3.016a9.308,9.308,0,0,1,1.305,4.142,6.8,6.8,0,0,1-.585,2.746c-.225.675-.405,1.215-.54,1.711-.09.45-.18.855-.225,1.125a5.355,5.355,0,0,0,1.125,3.376,13.565,13.565,0,0,0,2.926,2.431,21.8,21.8,0,0,0,3.421,1.4,4.543,4.543,0,0,1,.675.315l.675.27a2.885,2.885,0,0,1,1.08.945,2.828,2.828,0,0,1,1.08-.945c.315-.135.585-.225.855-.36.225-.09.405-.18.5-.225a3.474,3.474,0,0,0,.675-.27c.27-.09.585-.225.99-.36a9.7,9.7,0,0,0,1.711-.72,16.043,16.043,0,0,0,2.881-2.386A5.223,5.223,0,0,0,3.142-23.08a12.486,12.486,0,0,0-.765-2.746,8.383,8.383,0,0,1-.54-2.881Z",
    transform: "translate(16.575 36)",
    fill: "#41a6e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapShield);
export default __webpack_public_path__ + "static/media/map-shield.dc7203ebec7e7cab814a488fa51ac330.svg";
export { ForwardRef as ReactComponent };